import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=f51b7e38&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=f51b7e38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51b7e38",
  null
  
)

export default component.exports